import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { CompleteTemplate } from 'components/Templates'
import { useDispatch } from 'react-redux'
import { push } from 'connected-react-router'

const StoreDeliveryFeeComplete: FC = () => {
  const dispatch = useDispatch()
  const backToTop = () => dispatch(push('/'))
  return (
    <Layout title={'完了 | 配送料設定'}>
      <CompleteTemplate
        iconPath={'/icon/blue/delivery.svg'}
        label={'配送料設定が\n完了しました。'}
        backToTop={backToTop}
      />
    </Layout>
  )
}

export default StoreDeliveryFeeComplete
